export default "__VITE_ASSET__48147af4__"